/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signuptypesinglechoice3Inputs */

const en_signuptypesinglechoice3 = /** @type {(inputs: Signuptypesinglechoice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Single choice`)
};

const de_signuptypesinglechoice3 = /** @type {(inputs: Signuptypesinglechoice3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Auswahl`)
};

/**
* | output |
* | --- |
* | "Single choice" |
*
* @param {Signuptypesinglechoice3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signuptypesinglechoice3 = /** @type {((inputs?: Signuptypesinglechoice3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signuptypesinglechoice3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signuptypesinglechoice3(inputs)
	return de_signuptypesinglechoice3(inputs)
});
export { signuptypesinglechoice3 as "signupTypeSingleChoice" }